import React from 'react'
import { QuestionChoice } from '@mission.io/question-toolkit'
import { IoMdClose } from 'react-icons/io'
import { GoCheck } from 'react-icons/go'

import 'styled-components/macro'
import { styled } from 'styled-components'
import { isDropdownAnswer } from '../../utils'
import { StudentResponse } from '../../model/general'
import OptionalMarkdown from '../Markdown/OptionalMarkdown'
import { _tempTheme } from '../../utils/tempTheme'

interface ModalOptionsProps {
	options?: QuestionChoice[]
	handleClick: (index: number) => void
	index?: number
	studentResponse?: StudentResponse | null
	dropdownKey?: string
	isReview?: boolean
}

// Wrapper that display dropdown options for Student view
export const OptionsWrapper = (props: ModalOptionsProps): JSX.Element => {
	const {
		options,
		handleClick,
		index = -1,
		studentResponse,
		dropdownKey,
		isReview,
	} = props
	const haveIndex = index > -1

	return (
		<div role="dialog">
			{haveIndex && (
				<IndexChoice className="notranslate">{index + 1}</IndexChoice>
			)}
			<ModalContent $haveIndex={haveIndex}>
				{options &&
					options.map((item: QuestionChoice, index: number) => {
						const isCorrect = item.answer
						const isIncorrect =
							dropdownKey &&
							studentResponse &&
							isDropdownAnswer(studentResponse.answer) &&
							!item.answer &&
							studentResponse.answer.value[dropdownKey] === String(item._id)

						return studentResponse ? (
							<button
								key={`option-${index}`}
								className={`no-button ${
									isCorrect
										? 'is-correct'
										: isIncorrect
										? 'is-incorrect'
										: 'no-border'
								}`}
								disabled>
								<div className="button-content">
									<OptionalMarkdown>{item.text}</OptionalMarkdown>
									{isCorrect ? (
										<GoCheck className="icon-success" />
									) : isIncorrect ? (
										<IoMdClose className="icon-error" />
									) : null}
								</div>
							</button>
						) : (
							<button
								key={`option-${index}`}
								onClick={() => handleClick(index)}
								disabled={isReview}>
								<OptionalMarkdown>{item.text}</OptionalMarkdown>
							</button>
						)
					})}
			</ModalContent>
		</div>
	)
}

interface IModalContent {
	$haveIndex?: boolean
}
const ModalContent = styled.div<IModalContent>`
	display: flex;
	flex-direction: column;
	background-color: ${({ theme }) => theme.lightPrimaryColor};
	box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.45);
	border-radius: ${({ $haveIndex: haveIndex, theme }) =>
		`${haveIndex ? '0' : theme.spacing} ${_tempTheme.spacing2} ${
			_tempTheme.spacing2
		} ${_tempTheme.spacing2}`};
	padding: ${_tempTheme.spacing1} ${_tempTheme.spacing2};

	button {
		width: 100%;
		cursor: pointer;
		white-space: normal;
		padding: ${_tempTheme.spacing2};
		border: none;
		margin: ${_tempTheme.spacing1} auto;
		background: ${({ theme }) => theme.lightestPrimaryColor};
		border-radius: ${_tempTheme.spacing1};
		font-weight: ${_tempTheme.font_normal};
		font-size: ${_tempTheme.text_lg};
		line-height: 19px;
		color: #3a3333;
		text-align: start;
		&:hover:enabled {
			background-color: ${({ theme }) => theme.primaryButton.hover};
			border-color: ${({ theme }) => theme.primaryButton.hover};
			color: ${({ theme }) => theme.white};
		}
		&:focus {
			background-color: ${({ theme }) => theme.primaryButton.pressed};
			border-color: ${({ theme }) => theme.primaryButton.pressed};
			color: ${({ theme }) => theme.white};
		}
	}
	button.no-button {
		&:disabled {
			color: #3a3333 !important;
			background: #ddddf6 !important;
			cursor: default !important;
		}
	}
	button.is-correct {
		border: 4px solid ${({ theme }) => theme.success} !important;
	}
	button.is-incorrect {
		border: 4px solid ${({ theme }) => theme.error} !important;
	}
	button.no-border {
		border: none !important;
	}
	.button-content {
		display: flex;
		justify-content: space-between;
		align-item: center;
	}
	.icon-success {
		color: ${({ theme }) => theme.success};
	}
	.icon-error {
		color: ${({ theme }) => theme.error};
	}
`

const IndexChoice = styled.div`
	background: #272455;
	border-radius: ${_tempTheme.spacing2} 8px 0 0 ${_tempTheme.spacing2};
	color: ${({ theme }) => theme.white};
	padding: 12px;
`
export default OptionsWrapper
